import { createStore as _createStore } from "./persistedStore"
import { setStore } from "./storeAccessor"

export function initStore(preloadedState?: any) {
  // true = включаем persist только на клиенте
  const { store, persistor } = _createStore(preloadedState, typeof window !== "undefined")

  setStore(store)
  return { store, persistor }
}